import { styled, styledForMobile, Skeleton as UiSkeleton } from "@l2r-front/l2r-ui"

export const Container = styled("div")(({ theme }) => ({
    position: "relative",
    height: "100%",
    width: "100%",
    display: "flex",
    alignItems: "center",
    backgroundColor: theme.palette["secondary"].light,
    zIndex: 4,
}))

export const BottomRightContainer = styledForMobile("div")(({ isMobile, theme }) => ({
    position: "absolute",
    bottom: theme.spacing(isMobile ? 10 : 38),
    right: theme.spacing(2),
    zIndex: 101,
}))

export const BottomCenterContainer = styledForMobile("div")(({ isMobile, theme }) => ({
    position: "absolute",
    bottom: theme.spacing(isMobile ? 10 : 8),
    left: "50%",
    transform: "translateX(-50%)",
    zIndex: 101,
}))

export const TopRightContainer = styled("div")(({ theme }) => ({
    display: "flex",
    flexDirection: "column",
    alignItems: "flex-end",
    justifyContent: "flex-start",
    gap: theme.spacing(4),
    position: "absolute",
    top: theme.spacing(4),
    right: theme.spacing(2),
    zIndex: 101,
}))

export const CenterLeftContainer = styled("div")(({ theme }) => ({
    left: theme.spacing(6),
    position: "absolute",
    top: theme.spacing("50%"),
    transform: "translateY(-50%)",
    zIndex: 101,
}))

export const LoadingContainer = styled("div")(({ theme }) => ({
    backgroundColor: theme.palette["secondary"].light,
    position: "absolute",
    top: 0,
    height: "100%",
    width: "100%",
    zIndex: 100,
}))

export const Skeleton = styled(UiSkeleton)({
    height: "100%",
    transform: "scale(1)",
    width: "100%",
})

export const ImageViewerContainer = styled("div")({
    height: "100%",
    width: "100%",
})

export const ViewerLayer = styled("div", { shouldForwardProp: (prop) => prop !== "isActive" })(({ isActive }) => ({
    display: isActive ? "block" : "none",
    position: "relative",
    height: "100%",
    width: "100%",
}))
